module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "part",
    attrs: {
      "epub:type": "part"
    }
  }, [_c('h2', {
    staticClass: "centred firstInSection"
  }, [_vm._v("Part One")]), _vm._v(" "), _c('h3', {
    staticClass: "centred"
  }, [_c('em', [_vm._v("Australia 1870")])]), _vm._v(" "), _c('h3', {
    staticClass: "centred"
  }, [_vm._v("Ambitious Dreams")]), _vm._v(" "), _c('blockquote', {
    staticClass: "hanging_indent bq"
  }, [_c('p', {
    staticClass: " firstInSection"
  }, [_vm._v("When night moves in")]), _vm._v(" "), _c('p', [_vm._v("To hide the sun,")]), _vm._v(" "), _c('p', [_vm._v("When enemies rally")]), _vm._v(" "), _c('p', [_vm._v("And your strength is done,")]), _vm._v(" "), _c('p', [_vm._v("When your weary heart")]), _vm._v(" "), _c('p', [_vm._v("Longs to be free,")]), _vm._v(" "), _c('p', [_vm._v("Think of me, beloved,")]), _vm._v(" "), _c('p', [_vm._v("Think of me.")])]), _vm._v(" "), _c('p', {
    staticClass: "source_right"
  }, [_vm._v("J.C.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbe32110","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter3.vue
// module id = 72
// module chunks = 0